module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "订单追踪"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("正在加载...")]) : _vm._e(), _vm._v(" "), (_vm.nodata) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("无物流信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.expressInfosData), function(info, index) {
    return _c('div', [_c('divider', [_vm._v(_vm._s(info.expTextName) + " " + _vm._s(info.mailNo))]), _vm._v(" "), (info.data) ? _c('timeline', _vm._l((info.data), function(row, index) {
      return _c('timeline-item', {
        key: index
      }, [_c('h4', {
        class: [index === 0 ? 'recent' : '']
      }, [_vm._v(_vm._s(row.context))]), _vm._v(" "), _c('p', {
        class: [index === 0 ? 'recent' : '']
      }, [_vm._v(_vm._s(row.time))])])
    })) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-959b740e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/CourierInfo.vue
// module id = 599
// module chunks = 0